import moment from "moment";
import "moment/min/locales";

const getMomentLocale = (locale) => {
  if (!locale) return 'en';

  const normalizedLocale = locale.toLowerCase();
  const languageLocale = normalizedLocale.split('-')[0];
  const momentLocales = moment.locales();

  if (momentLocales.includes(normalizedLocale)) {
    return normalizedLocale;
  }

  return momentLocales.includes(languageLocale) ? languageLocale : 'en';
};

const formatWithLocale = (date, locale, format, useUtc = false) => {
  if (!date) return '';

  const momentLocale = getMomentLocale(locale);
  const localizedDate = (useUtc ? moment(parseInt(date, 10)).utc() : moment(date))
    .locale(momentLocale);
  const formattedDate = localizedDate.format(format);
  const localeData = moment.localeData(momentLocale);

  return localeData.preparse ? localeData.preparse(formattedDate) : formattedDate;
};

export const formatLocalizedPaymentDate = (date, locale, format) => {
  return formatWithLocale(date, locale, format);
};

export const formatLocalizedDate = (date, locale, format) => {
  return formatWithLocale(date, locale, format, true);
};
